import { PreferencesFormData } from '@/scopes/checkout/domain/types/checkoutPreferences'

export interface PreferencesFormDataMapper {
  map: (formData: PreferencesFormData) => Array<{
    code: string
    customerInput?: string
  }>
}

export function createPreferencesFormDataMapper(): PreferencesFormDataMapper {
  const map = (formData: PreferencesFormData) => {
    if (!formData) {
      return []
    }

    return Object.entries(formData).filter(([_key, preference]) => preference.selected).map(([_key, preference]) => {
      const basePreference = {
        code: preference.id,
      }

      if (preference.value !== undefined && preference.value !== null && preference.value !== preference.id) {
        return {
          ...basePreference,
          customerInput: String(preference.value),
        }
      }

      return basePreference
    })
  }

  return {
    map,
  }
}
